import { type SentEmailDetails, type SentEmailsPage } from "../../entities/SentEmail";
import { type CloudFunctionDefinition, type RouteMeta, typed } from "../cloudFunctions";

/**
 * trainee-api. Na razie tylko trasy wołane z panelu przez `callFn` (TRE-1715) —
 * reszta serwisu (webhooki Supabase, taski, crony) dopisze się, gdy ktoś będzie
 * jej potrzebował po stronie klienta. Deklarowanie ich „na zapas" tylko po to,
 * żeby lista wyglądała kompletnie, rozjeżdża się z rzeczywistością (TRE-1684).
 */
export const traineeRoutes = {
  healthCheck: typed<void, string>()({ method: "get", path: "/health-check", auth: "public" }),

  getSentEmails: typed<void, SentEmailsPage, { traineeId: string }, { count?: number; offset?: number }>()({
    method: "get",
    path: "/sent-emails/:traineeId",
    auth: "user",
  }),
  getSentEmail: typed<void, SentEmailDetails, { traineeId: string; messageId: string }>()({
    method: "get",
    path: "/sent-emails/:traineeId/:messageId",
    auth: "user",
  }),
} satisfies Record<string, RouteMeta>;

export const traineeFunction: CloudFunctionDefinition<typeof traineeRoutes> = {
  functionName: "trainee-api",
  region: "europe-west1",
  version: "v1",
  routes: traineeRoutes,
};
